import { Component, EventEmitter, OnInit, ViewChild, Output, } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { ModalAddReferenciaComponent } from '../modal-add-referencia/modal-add-referencia/modal-add-referencia.component';
import { ToastService } from 'ng-uikit-pro-standard';
import { TipoDTEService } from 'src/app/services/tipo-dte.service';

@Component({
  selector: 'app-modal-docs-referencia',
  templateUrl: './modal-docs-referencia.component.html',
  styleUrls: ['./modal-docs-referencia.component.scss']
})
export class ModalDocsReferenciaComponent implements OnInit {

  //Variables
  countSelectDoc: number = 0;
  // Modales
  @ViewChild('DocsReferencia', { static: true })
  modalDocsRef: ModalDirective;
  @ViewChild(ModalAddReferenciaComponent, { static: true }) modalAddDocsRef: ModalAddReferenciaComponent

  @Output() onCountListDocRef: EventEmitter<any> = new EventEmitter<any>()

  checkAll: boolean = false
  fechaDoc: string = '';
  listaDocRef: any = [];

  constructor(
    private toastService: ToastService,
    private tipoDteService: TipoDTEService
  ) { }

  ngOnInit() {
  }


  // VER MODAL TABLA DE DOCS REFERENCIA
  show(fechaDocCliente) {
    this.fechaDoc = fechaDocCliente;
    this.modalDocsRef.show();
  }


    // VER MODAL TABLA DE DOCS REFERENCIA DE NV
    showWhitConfig(fechaDocCliente, mode) {
      this.fechaDoc = fechaDocCliente;
      if(mode === 'ADD'){
        this.listaDocRef = [];
      }
      this.modalDocsRef.show();
    }

   // OBTENER ORDEN DE COMPRA DEL EDIT
   load(fechaDocCliente, docs) {
    this.fechaDoc = fechaDocCliente;
    if(docs == 0){
      this.listaDocRef = [];
    }else{
      this.listaDocRef = docs
    }

  }

  // OCULTAR MODAL TABLA DE DOCS REFERENCIA
  hide() {
    this.modalDocsRef.hide();
  }

  // ABRIR MODAL PARA AGREGAR DOC
  AddDocs(){
    this.modalAddDocsRef.show(this.listaDocRef,  this.fechaDoc);
  }

  //MOSTRAR LISTA DE DOC DESPUES DE GUARDAR
  getDocRef($event){
    this.listaDocRef = $event;
    this.listaDocRef.map(x=>{
      // x.fecha_dte_referencia = '0001-01-01T00:00:00'
      x.folio = 0;
      x.folio_referencia = 0;
      // x.monto_total = null;
      x.rut_emisor = 0;
      x.tipo_dte_codigo = 0;
      // x.tipo_ncnd_codigo = 0
      // x.tipoRefAcronimo = null;
    })

this.onCountListDocRef.emit(this.listaDocRef);
  }

  //SELECCION INDIVIDUAL
  checkDetalle({ index }, { checked }){

    this.listaDocRef.map(detalle => {
      if (detalle.index === index) {
        detalle.checked = checked
      }
    });
    //DESELECCIONAR EL CAMPO SELECT ALL
    const totalUnselected: number = this.listaDocRef.filter((detalle: any) => !detalle.checked).length
    this.checkAll = totalUnselected === 0

      //SUMA DE ELEMENTOS SELECCIONADOS
      this.countSelectDoc = this.listaDocRef.filter(x => x.checked === true).length;
  }

  //SELECCIONAR TODOS
  checkAllChange({ checked }) {
    this.listaDocRef.forEach(detalle => { detalle.checked = checked })
    //SELECCIONAR TODO
    this.checkAll = checked

     //ELEMENTOS SELECCIONADOS
     this.countSelectDoc = this.listaDocRef.filter(x => x.checked === true).length;
  }

  //ELIMINAR DOC REFRENCIA
  OnDeleteDetail() {
    var atleastOneSelected = this.listaDocRef.filter(checkbox => checkbox.checked === true);


    if (atleastOneSelected.length === 0) {
      this.countSelectDoc = 0;
      this.toastService.error('No existen docs de referencia')
      return
    }

    var UnSelectData = this.listaDocRef.filter(checkbox => checkbox.checked === false);
    this.listaDocRef = UnSelectData;

    if(this.listaDocRef.length === 0){
      this.listaDocRef = [];
    }

    this.countSelectDoc = 0;
    this.checkAll = false;

    this.onCountListDocRef.emit(this.listaDocRef);
    }


    clearData(){
      this.listaDocRef = [];

    }

}
